/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetDisputeRequest} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'
import {GetDisputeResponse} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'


export const getDispute = (request: GetDisputeRequest, options?: CashRequestOptions) => post<GetDisputeRequest, GetDisputeResponse>("/2.0/cash/get-dispute", request, {...options, rejectOnError: true })